import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import useIntelligentTimer from "./useIntelligentTimer";
const Context = createContext(undefined);
export const SleepingProvider = ({ children }) => {
    const [startTimer, stopTimer] = useIntelligentTimer();
    const [sleeping, setSleeping] = useState(false);
    // Allow subscriptions to wake/sleep events
    // This allows logic to know when the overlay was re-awoken, even if it was already awake
    const [callbacks, setCallbacks] = useState({
        wake: [],
        sleep: [],
    });
    const on = useCallback((event, fn) => {
        setCallbacks((prev) => (Object.assign(Object.assign({}, prev), { [event]: [...prev[event], fn] })));
    }, []);
    const off = useCallback((event, fn) => {
        setCallbacks((prev) => (Object.assign(Object.assign({}, prev), { [event]: prev[event].filter((f) => f !== fn) })));
    }, []);
    // Wake the overlay for x milliseconds
    const wake = useCallback((time) => {
        setSleeping(false);
        callbacks.wake.forEach((fn) => fn(time));
        startTimer(() => setSleeping(true), time);
    }, [callbacks.wake, startTimer]);
    // Immediately sleep the overlay
    const sleep = useCallback(() => {
        setSleeping(true);
        callbacks.sleep.forEach((fn) => fn());
        stopTimer();
    }, [callbacks.sleep, stopTimer]);
    // Expose the full object for sleeping
    const obj = useMemo(() => ({
        sleeping,
        wake,
        sleep,
        on,
        off,
    }), [sleeping, wake, sleep, on, off]);
    return _jsx(Context, { value: obj, children: children });
};
const useSleeping = () => {
    const ctx = useContext(Context);
    if (!ctx)
        throw new Error("useSleeping must be used within a SleepingProvider");
    return ctx;
};
export default useSleeping;
